var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 20 20",
    fill: "none",
    className: "tw-animate-spin-slow"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_25",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18C8.90667 18 7.87333 17.79 6.9 17.37C5.92667 16.95 5.07667 16.3767 4.35 15.65C3.62333 14.9233 3.05 14.0733 2.63 13.1C2.21 12.1267 2 11.0933 2 10C2 8.89333 2.21 7.85667 2.63 6.89C3.05 5.92333 3.62333 5.07667 4.35 4.35C5.07667 3.62333 5.92667 3.05 6.9 2.63C7.87333 2.21 8.90667 2 10 2V3.5C8.19444 3.5 6.65972 4.12847 5.39583 5.38542C4.13194 6.64236 3.5 8.17708 3.5 9.98958C3.5 11.8021 4.13308 13.3403 5.39923 14.6042C6.66537 15.8681 8.19896 16.5 10 16.5C11.8194 16.5 13.3576 15.8669 14.6146 14.6008C15.8715 13.3346 16.5 11.801 16.5 10H18C18 11.0972 17.79 12.1321 17.37 13.1045C16.95 14.0769 16.3767 14.9261 15.65 15.6521C14.9233 16.3781 14.0767 16.951 13.11 17.3706C12.1433 17.7902 11.1067 18 10 18Z",
    fill: "#e2e8f0"
  }))));
};
export default SvgSpinner;